'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'laptop';
var width = 640;
var height = 512;
var aliases = [128187];
var unicode = 'f109';
var svgPathData = ['M112 96c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 208-416 0 0-208z', 'M512 80L128 80c-8.8 0-16 7.2-16 16l0 208-48 0 0-208c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 208-48 0 0-208c0-8.8-7.2-16-16-16zM102.4 432l435.2 0c22.1 0 41.1-13.1 49.6-32L52.8 400c8.5 18.9 27.5 32 49.6 32zM0 377.6C0 363.5 11.5 352 25.6 352l588.8 0c14.1 0 25.6 11.5 25.6 25.6 0 56.6-45.8 102.4-102.4 102.4l-435.2 0C45.8 480 0 434.2 0 377.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLaptop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;